import { useCreateNewVisualUnitMutation } from '../../Redux/Workspace/workspaceActionsSlice'
import { useContext } from 'react'
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster'
import { VisualUnitApiDTO_VisualUnit } from '../../Interfaces/APIContracts/VisualUnitApiDTO_VisualUnit'
import { WorkspaceApiDTO_Workspace } from '../../Interfaces/APIContracts/WorkspaceApiDTO_Workspace'
import { useWorkspaceStore } from './workspaceContext'
import { getVuObjInfoState, setVuObjectInfoStore } from '../../Redux/VisualUnits/visualUnitStateSlice'
import { useDispatch, useSelector } from 'react-redux'
import { getVUObject } from '../../VisualunitHelpers'
declare let window: any
const UnicornApp = window.unicornInstance as any

interface useAddNewReportProps {
    WorkspaceId: string;
    setShowExportPopup: (flag: boolean) => void;

}
export const useAddNewReport = ({ WorkspaceId , setShowExportPopup }: useAddNewReportProps) => {
        const [createNewVisualUnit] = useCreateNewVisualUnitMutation()

    const currentWorkspaceData: WorkspaceApiDTO_Workspace = useWorkspaceStore((s) => s.workspaceState);
    const bulkUpdateVUs = useWorkspaceStore((s) => s.updateVisualUnits);
    const vuObjDataInfoFromStore = useSelector(getVuObjInfoState)
    const dispatch = useDispatch()

        
    const clickAddNewReport = () => {
        const selectedVUId = -1
        createNewVisualUnitDialog(selectedVUId, 'new', false)
            .then((resultData) => {
                if (resultData) {
                    if (resultData != null && resultData.MessageResults != null && resultData.newVU == null) {
                      setShowExportPopup(true);                       
                        for (let i = 0; i < resultData.MessageResults.length; i++) {
                            FoundationsGenericToaster('error', resultData.MessageResults[i].Message);
                        }
                    }
                    else {
                      const newReport: VisualUnitApiDTO_VisualUnit = { ...resultData.newVU }
                    newReport.TempVisualUnitId = -1
                    //FP-11694: No more reportdata, add to currentWorkspacedata directly.
                    let updatedVUList = [...currentWorkspaceData.VisualUnits]
                    updatedVUList.push(newReport);
                    bulkUpdateVUs(updatedVUList)

                    let newInfoFromStore = [...vuObjDataInfoFromStore]
                    let vuObject = getVUObject()
                    vuObject.id = newReport.VisualUnitId

                    newInfoFromStore.push(vuObject)

                    dispatch(setVuObjectInfoStore({ data: newInfoFromStore })) 
                    }
                    
                    
                }
            })
            .catch((err) => {
                console.error('Error in clickAddNewReport:', err)
            })
    }

    const createNewVisualUnitDialog = (
        vuId: number,
        operationMode: string,
        calledFromOldUI = false,
        copyReport = false
    ) => {
        const formData = new FormData()
        formData.append('VisualUnitId', vuId.toString())
        formData.append('WorkspaceId',WorkspaceId)
        return createNewVisualUnit(formData)
            .unwrap()
            .then((response) => {
                if (response) {
                    const resultData = response.data

                    if (resultData && resultData.MessageResults.length > 0) {
                        return resultData
                    } else {
                        FoundationsGenericToaster('error', 'No message results found.')
                        return null
                    }
                } else {
                    FoundationsGenericToaster('error', 'Unexpected error occurred.')
                    return null
                }
            })
            .catch((err) => {
                console.error('Error creating Visual Unit', err)
                FoundationsGenericToaster(
                    'error',
                    'Failed to create Visual Unit. Please try again.'
                )
                throw err
            })
    }

    return {
        clickAddNewReport,
    }
}
